import React, { memo, useCallback } from 'react';
import { CloseIcon } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { Tooltip, TooltipPlacement } from '@yme/atoms/tooltip';
import { useIsMount } from '@yme/hooks/index';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularLinkLevel2 } from '@yme/tokens/typography';
import { ItemPillStyled } from './styled';
function PillsComponent(props) {
    const { singlePill, multiplePills = [], isRightToLeft = false } = props;
    const isMount = useIsMount();
    const { t } = useTranslation();
    const handleDeleteSingleItemPill = useCallback(() => {
        if (singlePill) {
            singlePill.handleDelete(false);
        }
    }, [singlePill]);
    if (!isMount && (multiplePills.length || singlePill?.value)) {
        return (React.createElement(FlexWrapper, { gap: "12px", flexDirection: "row", flexWrap: "wrap" },
            singlePill?.value && (React.createElement(ItemPillStyled, { key: singlePill.groupId, justifyContent: "center", alignItems: "center", isRightToLeft: isRightToLeft, gap: "4px" },
                React.createElement(RegularLinkLevel2, { color: colorCoreBlack900Base }, singlePill.label),
                React.createElement(SVGIcon, { tabIndex: 0, size: ICON_SIZE.xxs, type: CloseIcon, onClick: handleDeleteSingleItemPill, "aria-label": t('common_cancel_button') }))),
            multiplePills.length > 0 &&
                multiplePills.map((item, index) => {
                    const groupId = item.groupId;
                    const finallyValue = item.value;
                    const finallyLabel = `${item?.label || groupId}: ${finallyValue}`;
                    return (React.createElement(ItemPillStyled, { key: groupId || index, justifyContent: "center", alignItems: "center", isRightToLeft: isRightToLeft, gap: "4px" },
                        item.fullToolTipLabel ? (React.createElement(Tooltip, { placement: isRightToLeft ? TooltipPlacement.ABOVE_LEFT : TooltipPlacement.ABOVE_RIGHT, title: item.fullToolTipLabel, hasEnableHoverListener: true },
                            React.createElement(RegularLinkLevel2, { color: colorCoreBlack900Base }, finallyLabel))) : (React.createElement(RegularLinkLevel2, { color: colorCoreBlack900Base }, finallyLabel)),
                        React.createElement(SVGIcon, { tabIndex: 0, size: ICON_SIZE.xxs, type: CloseIcon, onClick: () => item.handleDelete(groupId) })));
                })));
    }
    return null;
}
export const Pills = memo(PillsComponent);
